export default "__VITE_ASSET__C4uy_Vng__"